import type { Profile } from "@circle-react/types/CommunityBot/Profile";

import { useOpenAvatarConversation } from "./useOpenAvatarConversation";
import { useStartAvatarDmChat } from "./useStartAvatarDmChat";

export const useAskAvatar = () => {
  const { canOpenInWidget, openInWidget } = useOpenAvatarConversation();
  const startDmChat = useStartAvatarDmChat();

  return (avatar: Profile, question: string) => {
    if (canOpenInWidget(avatar)) {
      openInWidget(avatar);
      return;
    }
    startDmChat(avatar, question);
  };
};
